import React, { useState, useEffect } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import { getLabelAndValue } from "../../CommonFuntion/SchemaValidation";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useLocation, createSearchParams } from "react-router-dom";
import { titleCase } from "../../CommonFuntion/SchemaValidation";
import { useSelector } from 'react-redux';

export function Label(props) {
  const {
    selectedOption,
    name,
    label,
    options,
    value,
    tagName,
    prefix,
    validation,
    handleDropdownChange,
    showImage,
    user_id,
  } = props;

  const location = useLocation();
  const searchParams = createSearchParams(location.search);
  const { setFieldValue, values } = useFormikContext();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filteredOptions,setFilteredOptions] = useState(options);

  const labelTypeArray = useSelector((state) => state.LabelTypeLogic.labelTypeArray);

  useEffect(() => {
    const localStorageKey = `${user_id}${
      searchParams.get("label") || searchParams.get("PageID")
    }${name}singleSelectLabelImageData`;

    const localStorageData = localStorage.getItem(localStorageKey);
    const imageData = localStorageData ? JSON.parse(localStorageData) : null;

    if (imageData) {
      const optionsArray = imageData.newValue || [];
      const currentValue = getLabelAndValue(values?.[name])[0];

      if (optionsArray && currentValue && currentValue === optionsArray.value) {
        setSelectedOptions(optionsArray);
      }
    }
  }, [location.search, values?.[name], name, user_id, searchParams]);

  useEffect(() => {
    const hasRfid = labelTypeArray.includes('rfid');
    const hasNonRfid = labelTypeArray.includes('non_rfid');

    const finalOptions = filterLabel(options,hasRfid,hasNonRfid);
    setFilteredOptions(finalOptions);

  },[labelTypeArray]);

  const filterLabel = (options, hasRfid, hasNonRfid) =>{

      if (hasRfid && hasNonRfid)
        return options;
      
      if (hasRfid)
         return options.filter(item => item.label.toLowerCase().includes('rfid'));

      if (hasNonRfid) 
         return options.filter(item => !item.label.toLowerCase().includes('rfid'));

     return options;
  }
  const handleAutocompleteChange = (e, newValue) => {
    if (showImage) {
      setSelectedOptions(newValue);
      const localStorageKey = `${user_id}${
        searchParams.get("label") || searchParams.get("PageID")
      }${name}singleSelectLabelImageData`;

      localStorage.setItem(localStorageKey, JSON.stringify({ newValue }));
    }

    setFieldValue(name, newValue ? newValue.value : "");

    if (validation?.LableTableMapPart) {
      handleDropdownChange(
        newValue ? newValue.value : "",
        validation.LableTableMapPart
      );
    }
  };

  return (
    <div className="flex-container">
      <div className="control-bottom-border">
        {label && (
          <label className="font-css">
            {titleCase(label.replace("_", " "))}
            {validation?.mandatory && (
              <span className="mandatory-validation">{"*"}</span>
            )}
          </label>
        )}
      </div>

      <div className="control-bottom-border">
        <Autocomplete
          id={tagName}
          name={name}
          key={name}
          tagname={tagName}
          fieldname={name}
          prefix={prefix}
          className="control-width-font"
          style={{ fontSize: "12px" }}
          options={filteredOptions || []}
          value={
            filteredOptions?.find((option) => option.value === values?.[name]) || null
          }
          onChange={handleAutocompleteChange}
          renderInput={(params) => <TextField {...params} variant="standard" />}
          isOptionEqualToValue={(option, value) => {
            if (option && value && typeof option === 'object' && typeof value === 'object') {
              return option.value === value.value;
            }
            return option.value === value;
          }}
        />
        <ErrorMessage
          name={name}
          render={(msg) => <div className="is-invalid">{msg}</div>}
        />
      </div>

      {selectedOptions?.value &&
        showImage &&
        values[name] === selectedOptions.value && (
          <div className="image-card">
            <div className="font-css">{selectedOptions.imageId}</div>
            <img
              src={`${process.env.REACT_APP_SITE_URL}/Pages/Utils/ShowImage.ashx?Category=${selectedOptions.imageCategoryId}&ImageID=${selectedOptions.imageId}`}
              alt={`Image ${selectedOptions.imageId}`}
            />
          </div>
        )}
    </div>
  );
}
